import React from 'react';
import { colorValueToSwatchColors } from '../utils/colorSwatch';

/**
 * A single color swatch dot - solid for a plain value ("Blue"), or split into equal
 * wedges for a combo value ("Ruby+Green", "Ruby/Green", "Ruby and Green") so two-tone
 * products can be represented the same way jewelry catalog sites usually do it.
 * Shared between the product-card swatches (ProductMediaWithSwatches) and the product
 * page's color picker (ProductDetail) so both render identically.
 */
export default function ColorDot({ value, size = 16, selected = false, disabled = false, onClick, className = '' }) {
  const colors = colorValueToSwatchColors(value);
  const swatchStyle =
    colors.length <= 1
      ? { backgroundColor: colors[0] }
      : {
          background: `conic-gradient(${colors
            .map((c, i) => `${c} ${(360 / colors.length) * i}deg ${(360 / colors.length) * (i + 1)}deg`)
            .join(', ')})`
        };

  return (
    <button
      type="button"
      title={value}
      aria-label={value}
      disabled={disabled}
      onClick={onClick}
      style={{ width: size, height: size, ...swatchStyle }}
      className={`rounded-full shrink-0 transition-all ${
        selected ? 'ring-2 ring-indigo-600 ring-offset-1' : 'ring-1 ring-gray-300'
      } ${disabled ? 'opacity-30 cursor-not-allowed' : ''} ${className}`}
    />
  );
}
